import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import asyncLoadView from 'utils/asyncLoadView/asyncLoadView';
import routeArgsToInt from 'router/utils/routeArgsToInt';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const projectSettingsRoutes = [
  {
    path: 'settings',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Settings')
      },
      permissions: ['UPDATE_PROJECT']
    },
    children: [
      {
        path: '',
        name: 'projectSettings',
        component: wrapLegacyRoute('projectsController', 'settings')
      },
      {
        path: 'custommetrics',
        name: 'customMetrics',
        component: () => asyncLoadView(import('pages/projects/CustomMetricsPage/CustomMetricsPage')),
        props: routeArgsToInt,
        meta: {
          requiresComponents: ['CUSTOM_METRICS'],
          routeName: {
            segmentName: () => translation.tr('Custom metrics')
          }
        }
      },
      {
        path: 'webanalytics',
        component: NestedRouteComponent,
        meta: {
          routeName: {
            segmentName: () => translation.tr('Web Analytics')
          }
        },
        children: [

          // support legacy urls
          {
            path: '/accounts/:accountId(\\d+)/projects/:projectId(\\d+)/webanalytics',
            redirect: {name: 'webAnalyticsProfiles'}
          },
          {
            path: '/accounts/:accountId(\\d+)/projects/:projectId(\\d+)/webanalytics/profile/:profileId(\\d+)',
            redirect: {name: 'webAnalyticsProfileDetails'}
          },

          {
            path: '',
            name: 'webAnalyticsProfiles',
            component: () => asyncLoadView(import('pages/projects/profiles/ProfilesListPage')),
            props: routeArgsToInt
          },
          {
            path: 'profile/:profileId(\\d+)',
            name: 'webAnalyticsProfileDetails',
            component: () => asyncLoadView(import('pages/projects/profiles/ProfileDetailsPage')),
            props: routeArgsToInt
          },
          {
            path: 'profile/:profileId(\\d+)/setup',
            name: 'webAnalyticsProfileSetupDetails',
            component: () => asyncLoadView(import('pages/projects/profiles/ProfileSetupDetailsPage')),
            props: routeArgsToInt
          },
          {
            path: 'profile/:profileId(\\d+)/utm',
            name: 'webAnalyticsProfileUTMSetup',
            component: () => asyncLoadView(import('pages/projects/profiles/ProfileUTMSetupPage')),
            props: routeArgsToInt
          },
          {
            path: 'connections/create',
            name: 'projectWebanalyticsConnectionCreate',
            component: () => asyncLoadView(import('pages/connections/webanalytics/CreateWebanalyticsConnectionPage')),
            props: routeArgsToInt
          },

          /*
           * Warning: if changing route check it in WA-connection wizard, this urls are hardcoded,
           * because they are formatted on backend side
           */
          {
            path: 'connections/:waConnectionId(\\d+)/setup',
            name: 'projectWebanalyticsConnectionSetup',
            component: () => asyncLoadView(import('pages/connections/webanalytics/WebanalyticsConnectionSetupPage')),
            props: routeArgsToInt
          },
          {
            path: 'connections/pending/:pendingWaConnectionId(\\d+)/setup',
            name: 'projectWebanalyticsPendingConnectionSetup',
            component: () => asyncLoadView(import('pages/connections/webanalytics/PendingWebanalyticsConnectionSetupPage')),
            props: routeArgsToInt
          }
        ]
      }

    ]
  }
];

export default projectSettingsRoutes;
